/* eslint-disable react/react-in-jsx-scope */
// import
import SignIn from "views/Auth/SignIn.js";

import {
  HomeIcon,
  DocumentIcon,
  StatsIcon
} from "components/Icons/Icons";
import UnisonoGraphs from "views/Dashboard/Dashboard/Companies/components/UnisonoFeaturesGraph/UnisonoGraphs";
import BoxPlots from "views/Dashboard/Dashboard/BoxPlots";
import HeatTables from "views/Dashboard/Dashboard/HeatTables";

const getDashRoutes = () => {

  return [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: <HomeIcon color="inherit" />,
      component: UnisonoGraphs,
      layout: "/admin",
      showSidebar: true
    },
    {
      path: "/box-plots",
      name: "Box Plots",
      icon: <StatsIcon color="inherit" />,
      component: BoxPlots,
      layout: "/admin",
      showSidebar: true
    },
    {
      path: "/heat-tables",
      name: "Heat Tables",
      icon: <StatsIcon color="inherit" />,
      component: HeatTables,
      layout: "/admin",
      showSidebar: true
    },
    {
      path: "https://docs.zana.ai/docs/features/general",
      name: "Feature Documentation",
      icon: <DocumentIcon color="inherit" />,
      component: null,
      layout: "",
      external: true,
      showSidebar: true
    },
    {
      category: "account",
      state: "pageCollapse",
      views: [
        {
          path: "/signin",
          name: "Sign In",
          icon: <DocumentIcon color="inherit" />,
          component: SignIn,
          layout: "/auth",
        },
      ],
    },
  ];
};

export default getDashRoutes;
